<template>
  <div class="flex flex-col">
    <w-modal-image
      @close="showImage = false"
      v-if="showImage"
      :imageSrc="showImage"
    />
    <w-upload-receipt
      @close="upload = null"
      v-if="upload"
      :inscription="upload"
      :event-price="eventPrice"
    />

    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <div
          class="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg"
        >
          <table class="w-full divide-y divide-gray-300 md:min-w-full">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-50"
                >
                  Nombre
                </th>
                <th
                  v-if="hide.indexOf('event') == -1"
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-50"
                >
                  Productos
                </th>
                <th
                  class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase md:table-cell bg-gray-50"
                >
                  Total
                </th>
                <th
                  class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase md:table-cell bg-gray-50"
                >
                  Estado
                </th>
                <th class="px-6 py-3 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-300">
              <tr v-for="inscription in items" :key="inscription._id">
                <td class="px-6 py-3 overflow-hidden whitespace-nowrap">
                  <div v-if="inscription.customer" class="w-24 md:w-auto">
                    <div
                      v-if="inscription.customer.name"
                      class="text-xs font-medium leading-5 text-gray-900 md:text-sm"
                    >
                      {{ inscription.customer.name }}
                    </div>
                    <div
                      v-if="!inscription.customer.name"
                      class="text-xs italic font-medium leading-5 text-gray-400 md:text-sm"
                    >
                      Sin Nombre
                    </div>
                    <div
                      v-if="inscription.customer.phone"
                      class="flex items-center text-xs leading-5 text-gray-500 md:text-sm"
                    >
                      <div>{{ inscription.customer.phone }}</div>
                      <a
                        v-bind:href="inscription.customer.phone | whatsapp"
                        target="_blank"
                        ><svg
                          style="color: #25d366"
                          class="w-3 h-3 ml-1 cursor-pointer"
                          fill="currentColor"
                          role="img"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <title>WhatsApp icon</title>
                          <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
                          /></svg
                      ></a>
                    </div>
                    <div class="text-xs leading-5 text-gray-500 md:text-sm">
                      {{ inscription.customer.email }}
                    </div>
                  </div>
                  <div class="text-xs italic text-gray-500">
                    hace {{ inscription.createdAt | moment("from", true) }}
                  </div>
                </td>
                <td
                  v-if="hide.indexOf('event') == -1 && inscription.event"
                  class="px-6 py-4 whitespace-nowrap"
                >
                  <div
                    v-tooltip="inscription.event.subtitle"
                    class="flex items-center text-sm font-medium leading-5 text-gray-900"
                  >
                    <div>{{ inscription.event.name }}</div>
                  </div>
                  <div
                    class="hidden text-xs leading-5 text-gray-500 md:table-cell"
                  >
                    <span v-if="!inscription.event.allMonth">
                      {{
                        $moment(inscription.event.date).format("dddd D MMMM")
                          | capitalize
                      }}
                    </span>
                    <div class="flex items-center" v-else>
                      <div
                        v-tooltip="'Evento con frecuencia semanal'"
                        class="mr-1"
                      >
                        <svg
                          class="w-4 h-4 text-blue-500"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      Evento Recurrente
                      <!-- {{ $moment(inscription.event.date).format("dddd") | capitalize }}s -->
                    </div>
                  </div>
                </td>
                <td
                  class="hidden px-6 py-4 text-sm whitespace-nowrap md:table-cell"
                >
                  <div>
                    <w-price
                      v-if="inscription.event"
                      :value="
                        inscription.paidAmount ||
                        Number(inscription.event.price.ars)
                      "
                    ></w-price>
                  </div>
                  <div class="text-xs">
                    <div
                      v-if="inscription.method == 'wire'"
                      class="text-gray-500"
                    >
                      Bancario
                    </div>
                    <div
                      v-if="inscription.method == 'mercadopago'"
                      class="text-gray-500"
                    >
                      Mercado Pago
                    </div>
                    <div
                      v-if="inscription.method == 'paypal'"
                      class="text-gray-500"
                    >
                      Paypal
                    </div>
                    <div
                      v-if="inscription.method == 'stripe'"
                      class="text-gray-500"
                    >
                      Stripe
                    </div>
                    <div
                      v-if="inscription.method == 'free'"
                      class="text-gray-500"
                    >
                      Gratis
                    </div>
                  </div>
                </td>
                <td class="hidden px-6 py-4 whitespace-nowrap md:table-cell">
                  <span
                    v-if="inscription.payment == 'paid'"
                    class="inline-flex px-2 text-xs font-medium leading-5 text-green-100 bg-green-500 rounded-full"
                  >
                    Aprobado
                  </span>
                  <span
                    v-if="inscription.payment == 'sent'"
                    class="inline-flex px-2 text-xs font-medium leading-5 text-white bg-red-500 rounded-full"
                  >
                    Verificar Comprobante
                  </span>
                  <span
                    v-if="inscription.payment == 'pending'"
                    class="inline-flex px-2 text-xs font-medium leading-5 text-orange-100 bg-orange-400 rounded-full"
                  >
                    Pendiente
                  </span>
                  <span
                    v-if="!inscription.payment"
                    class="inline-flex px-2 text-xs font-medium leading-5 text-orange-100 bg-orange-400 rounded-full"
                  >
                    Pendiente
                  </span>
                </td>
                <td
                  class="px-6 py-4 text-sm font-medium leading-5 text-right whitespace-nowrap"
                >
                  <!-- <a href="#" class="text-indigo-600 hover:text-indigo-900">Edit</a> -->
                  <div class="relative">
                    <v-popover offset="5" placement="auto" class="inline-block">
                      <div class="rounded-md shadow-sm">
                        <button
                          type="button"
                          class="flex items-center justify-center w-full px-2 py-1 text-xs font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:bg-gray-50 active:text-gray-800"
                          id="options-menu"
                          aria-haspopup="menu"
                          aria-expanded="true"
                        >
                          <span class="hidden md:block">Acciones</span>
                          <span class="block md:hidden">
                            <svg
                              class="w-3 h-3"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h16"
                              />
                            </svg>
                          </span>
                          <!-- Heroicon name: chevron-down -->
                          <svg
                            class="w-5 h-5 ml-1 -mr-1"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>

                      <template slot="popover" class="p-0 m-0">
                        <div
                          class="p-1 py-1 text-xs text-left hover:bg-gray-100"
                        >
                          <router-link
                            class="flex items-center cursor-pointer"
                            :to="{
                              name: 'stores-id-products',
                              params: {
                                id: 'props.row.id',
                              },
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              />
                            </svg>

                            Editar inscripción</router-link
                          >
                        </div>
                        <div
                          class="p-1 py-1 text-xs text-left hover:bg-gray-100"
                        >
                          <router-link
                            class="flex items-center cursor-pointer"
                            :to="{
                              name: 'stores-id-products',
                              params: {
                                id: 'props.row.id',
                              },
                            }"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>

                            Ver Participante</router-link
                          >
                        </div>
                        <div
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                            />
                          </svg>

                          Reenviar Confirmación
                        </div>
                        <div
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24px"
                            height="24px"
                          >
                            <path
                              d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"
                            />
                          </svg>

                          Enviar Whatsapp
                        </div>
                        <div
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                          </svg>

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                            />
                          </svg>

                          Enlace de pago
                        </div>
                        <div
                          v-if="!inscription || true"
                          @click="upload = inscription"
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                          Cargar comprobante
                        </div>
                        <a
                          v-if="inscription.receipt"
                          @click="
                            showImage = inscription.receipt.replace(
                              'pdf',
                              'png'
                            )
                          "
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
                            />
                          </svg>
                          Ver comprobante
                        </a>
                        <div
                          v-if="inscription.receipt"
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-gray-100"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                            />
                          </svg>
                          Aprobar comprobante
                        </div>
                        <div
                          class="flex items-center p-1 py-1 text-xs text-left border-t border-gray-200 cursor-pointer hover:bg-red-500 hover:text-white"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>

                          Eliminar
                        </div>
                      </template>
                    </v-popover>
                  </div>
                </td>
              </tr>

              <!-- More rows... -->
            </tbody>
          </table>
          <div
            v-if="totalResults > limit"
            @click="nextPage()"
            class="items-center p-3 text-sm font-medium text-center text-indigo-300 cursor-pointer glex hover:text-indigo-500"
          >
            Cargar 20 más de {{ totalResults - limit }} resultados.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    hide: {
      type: Array,
      default: () => [],
    },
    totalResults: {
      type: Number,
      default: 0,
    },
    eventPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showImage: null,
      upload: null,
      limit: 20,
    };
  },
  methods: {
    nextPage() {
      this.limit += 20;
      this.$emit("next-page", this.limit);
    },
  },
};
</script>

<style lang="scss" scoped></style>
